export default {"src":"/_next/static/media/secure-storage.24a39cf9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};